import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/app/search/[category]/error.tsx");
